var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-combobox',{attrs:{"items":_vm.availableRolesEnums,"chips":"","label":_vm.$t('backoffice.user.user-roles.title'),"multiple":"","prepend-icon":"mdi-shield-check"},on:{"change":_vm.changeRolesDebounce},scopedSlots:_vm._u([{key:"selection",fn:function(ref){
var attrs = ref.attrs;
var item = ref.item;
var select = ref.select;
var selected = ref.selected;
return [_c('v-chip',_vm._b({attrs:{"input-value":selected},on:{"click":select}},'v-chip',attrs,false),[_c('strong',[_vm._v(_vm._s(item))])])]}}]),model:{value:(_vm.assignedRoles),callback:function ($$v) {_vm.assignedRoles=$$v},expression:"assignedRoles"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }